import type { Tier } from '@topmeeps/shared'
import { TierBadge } from './TierBadge'

export type RatingChipProps = {
  mu: number
  tier: Tier | null
  compact?: boolean
}

export const RatingChip = ({ mu, tier, compact }: RatingChipProps) => (
  <TierBadge tier={tier} score={mu} compact={compact} />
)
